import React from "react";
import "responsive.css";
import "style.css";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "var(--color-bg-darker)",
        borderTop: "solid 4px var(--color-footer-border)",
        padding: "20px",
        textAlign: "center",
      }}
    >
      <p
        style={{
          color: "var(--color-text-muted)",
          fontSize: "14px",
          marginBottom: "6px",
        }}
      >
        Contact us:{" "}
        <a
          href={`mailto:${process.env.REACT_APP_CONTACT_EMAIL || "muengrsurf@missouri.edu"}`}
          style={{ color: "var(--color-primary)", textDecoration: "none" }}
        >
          {process.env.REACT_APP_CONTACT_EMAIL || "muengrsurf@missouri.edu"}
        </a>
      </p>
      <p style={{ color: "var(--color-text-muted)", fontSize: "12px" }}>
        © 2025 Mizzou SURF
      </p>
    </footer>
  );
};

export default Footer;
